var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.v-secondary.nonInteractive",value:(`${_vm.tooltip_text}`),expression:"`${tooltip_text}`",modifiers:{"v-secondary":true,"nonInteractive":true}}],staticClass:"icon-help",attrs:{"icon":"info-circle-fill","scale":"1","variant":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }